import { g as on, t as sn } from "./tailwind.config-CZrDE384.js";
import { watch as Ge, onMounted as Rt, nextTick as un, getCurrentInstance as Qe, hasInjectionContext as Vt, inject as ln, getCurrentScope as dn, onScopeDispose as cn, toValue as X, shallowRef as Z, computed as se, watchEffect as fn, unref as mn } from "vue";
import { e as pn } from "./_plugin-vue_export-helper-qbMel8wb.js";
var ge = {}, be = {}, ve = {}, tt;
function Ht() {
  return tt || (tt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      if (n = `${n}`, n === "0")
        return "0";
      if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(n))
        return n.replace(/^[+-]?/, (a) => a === "-" ? "" : "-");
      let r = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
      ];
      for (const a of r)
        if (n.includes(`${a}(`))
          return `calc(${n} * -1)`;
    }
  }(ve)), ve;
}
var ye = {}, nt;
function hn() {
  return nt || (nt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const t = [
      "preflight",
      "container",
      "accessibility",
      "pointerEvents",
      "visibility",
      "position",
      "inset",
      "isolation",
      "zIndex",
      "order",
      "gridColumn",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRow",
      "gridRowStart",
      "gridRowEnd",
      "float",
      "clear",
      "margin",
      "boxSizing",
      "lineClamp",
      "display",
      "aspectRatio",
      "size",
      "height",
      "maxHeight",
      "minHeight",
      "width",
      "minWidth",
      "maxWidth",
      "flex",
      "flexShrink",
      "flexGrow",
      "flexBasis",
      "tableLayout",
      "captionSide",
      "borderCollapse",
      "borderSpacing",
      "transformOrigin",
      "translate",
      "rotate",
      "skew",
      "scale",
      "transform",
      "animation",
      "cursor",
      "touchAction",
      "userSelect",
      "resize",
      "scrollSnapType",
      "scrollSnapAlign",
      "scrollSnapStop",
      "scrollMargin",
      "scrollPadding",
      "listStylePosition",
      "listStyleType",
      "listStyleImage",
      "appearance",
      "columns",
      "breakBefore",
      "breakInside",
      "breakAfter",
      "gridAutoColumns",
      "gridAutoFlow",
      "gridAutoRows",
      "gridTemplateColumns",
      "gridTemplateRows",
      "flexDirection",
      "flexWrap",
      "placeContent",
      "placeItems",
      "alignContent",
      "alignItems",
      "justifyContent",
      "justifyItems",
      "gap",
      "space",
      "divideWidth",
      "divideStyle",
      "divideColor",
      "divideOpacity",
      "placeSelf",
      "alignSelf",
      "justifySelf",
      "overflow",
      "overscrollBehavior",
      "scrollBehavior",
      "textOverflow",
      "hyphens",
      "whitespace",
      "textWrap",
      "wordBreak",
      "borderRadius",
      "borderWidth",
      "borderStyle",
      "borderColor",
      "borderOpacity",
      "backgroundColor",
      "backgroundOpacity",
      "backgroundImage",
      "gradientColorStops",
      "boxDecorationBreak",
      "backgroundSize",
      "backgroundAttachment",
      "backgroundClip",
      "backgroundPosition",
      "backgroundRepeat",
      "backgroundOrigin",
      "fill",
      "stroke",
      "strokeWidth",
      "objectFit",
      "objectPosition",
      "padding",
      "textAlign",
      "textIndent",
      "verticalAlign",
      "fontFamily",
      "fontSize",
      "fontWeight",
      "textTransform",
      "fontStyle",
      "fontVariantNumeric",
      "lineHeight",
      "letterSpacing",
      "textColor",
      "textOpacity",
      "textDecoration",
      "textDecorationColor",
      "textDecorationStyle",
      "textDecorationThickness",
      "textUnderlineOffset",
      "fontSmoothing",
      "placeholderColor",
      "placeholderOpacity",
      "caretColor",
      "accentColor",
      "opacity",
      "backgroundBlendMode",
      "mixBlendMode",
      "boxShadow",
      "boxShadowColor",
      "outlineStyle",
      "outlineWidth",
      "outlineOffset",
      "outlineColor",
      "ringWidth",
      "ringColor",
      "ringOpacity",
      "ringOffsetWidth",
      "ringOffsetColor",
      "blur",
      "brightness",
      "contrast",
      "dropShadow",
      "grayscale",
      "hueRotate",
      "invert",
      "saturate",
      "sepia",
      "filter",
      "backdropBlur",
      "backdropBrightness",
      "backdropContrast",
      "backdropGrayscale",
      "backdropHueRotate",
      "backdropInvert",
      "backdropOpacity",
      "backdropSaturate",
      "backdropSepia",
      "backdropFilter",
      "transitionProperty",
      "transitionDelay",
      "transitionDuration",
      "transitionTimingFunction",
      "willChange",
      "contain",
      "content",
      "forcedColorAdjust"
    ];
  }(ye)), ye;
}
var we = {}, rt;
function gn() {
  return rt || (rt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n, r) {
      return n === void 0 ? r : Array.isArray(n) ? n : [
        ...new Set(r.filter((i) => n !== !1 && n[i] !== !1).concat(Object.keys(n).filter((i) => n[i] !== !1)))
      ];
    }
  }(we)), we;
}
var xe = {}, Pe = {}, de = { exports: {} }, at;
function It() {
  if (at) return de.exports;
  at = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return de.exports = t(), de.exports.createColors = t, de.exports;
}
var ot;
function Ke() {
  return ot || (ot = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(u, s) {
      for (var d in s) Object.defineProperty(u, d, {
        enumerable: !0,
        get: s[d]
      });
    }
    t(e, {
      dim: function() {
        return o;
      },
      default: function() {
        return l;
      }
    });
    const n = /* @__PURE__ */ r(/* @__PURE__ */ It());
    function r(u) {
      return u && u.__esModule ? u : {
        default: u
      };
    }
    let a = /* @__PURE__ */ new Set();
    function i(u, s, d) {
      typeof process < "u" && process.env.JEST_WORKER_ID || d && a.has(d) || (d && a.add(d), console.warn(""), s.forEach((c) => console.warn(u, "-", c)));
    }
    function o(u) {
      return n.default.dim(u);
    }
    const l = {
      info(u, s) {
        i(n.default.bold(n.default.cyan("info")), ...Array.isArray(u) ? [
          u
        ] : [
          s,
          u
        ]);
      },
      warn(u, s) {
        i(n.default.bold(n.default.yellow("warn")), ...Array.isArray(u) ? [
          u
        ] : [
          s,
          u
        ]);
      },
      risk(u, s) {
        i(n.default.bold(n.default.magenta("risk")), ...Array.isArray(u) ? [
          u
        ] : [
          s,
          u
        ]);
      }
    };
  }(Pe)), Pe;
}
var it;
function bn() {
  return it || (it = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const t = /* @__PURE__ */ n(Ke());
    function n(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    function r({ version: i, from: o, to: l }) {
      t.default.warn(`${o}-color-renamed`, [
        `As of Tailwind CSS ${i}, \`${o}\` has been renamed to \`${l}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const a = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return r({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return r({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return r({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return r({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return r({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  }(xe)), xe;
}
var ke = {}, st;
function vn() {
  return st || (st = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "defaults", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n, ...r) {
      for (let o of r) {
        for (let l in o) {
          var a;
          !(n == null || (a = n.hasOwnProperty) === null || a === void 0) && a.call(n, l) || (n[l] = o[l]);
        }
        for (let l of Object.getOwnPropertySymbols(o)) {
          var i;
          !(n == null || (i = n.hasOwnProperty) === null || i === void 0) && i.call(n, l) || (n[l] = o[l]);
        }
      }
      return n;
    }
  }(ke)), ke;
}
var Oe = {}, ut;
function yn() {
  return ut || (ut = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "toPath", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      if (Array.isArray(n)) return n;
      let r = n.split("[").length - 1, a = n.split("]").length - 1;
      if (r !== a)
        throw new Error(`Path is invalid. Has unbalanced brackets: ${n}`);
      return n.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
    }
  }(Oe)), Oe;
}
var Me = {}, We = {}, lt;
function Je() {
  return lt || (lt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, h) {
      for (var m in h) Object.defineProperty(c, m, {
        enumerable: !0,
        get: h[m]
      });
    }
    t(e, {
      flagEnabled: function() {
        return l;
      },
      issueFlagNotices: function() {
        return s;
      },
      default: function() {
        return d;
      }
    });
    const n = /* @__PURE__ */ a(/* @__PURE__ */ It()), r = /* @__PURE__ */ a(Ke());
    function a(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }
    let i = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    }, o = {
      future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
      ],
      experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
      ]
    };
    function l(c, h) {
      if (o.future.includes(h)) {
        var m, f, M;
        return c.future === "all" || ((M = (f = c == null || (m = c.future) === null || m === void 0 ? void 0 : m[h]) !== null && f !== void 0 ? f : i[h]) !== null && M !== void 0 ? M : !1);
      }
      if (o.experimental.includes(h)) {
        var S, F, L;
        return c.experimental === "all" || ((L = (F = c == null || (S = c.experimental) === null || S === void 0 ? void 0 : S[h]) !== null && F !== void 0 ? F : i[h]) !== null && L !== void 0 ? L : !1);
      }
      return !1;
    }
    function u(c) {
      if (c.experimental === "all")
        return o.experimental;
      var h;
      return Object.keys((h = c?.experimental) !== null && h !== void 0 ? h : {}).filter((m) => o.experimental.includes(m) && c.experimental[m]);
    }
    function s(c) {
      if (process.env.JEST_WORKER_ID === void 0 && u(c).length > 0) {
        let h = u(c).map((m) => n.default.yellow(m)).join(", ");
        r.default.warn("experimental-flags-enabled", [
          `You have enabled experimental features: ${h}`,
          "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
      }
    }
    const d = o;
  }(We)), We;
}
var dt;
function wn() {
  return dt || (dt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeConfig", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const t = Je(), n = /* @__PURE__ */ a(Ke());
    function r(o) {
      if (typeof WeakMap != "function") return null;
      var l = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap();
      return (r = function(s) {
        return s ? u : l;
      })(o);
    }
    function a(o, l) {
      if (o && o.__esModule)
        return o;
      if (o === null || typeof o != "object" && typeof o != "function")
        return {
          default: o
        };
      var u = r(l);
      if (u && u.has(o))
        return u.get(o);
      var s = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var c in o)
        if (c !== "default" && Object.prototype.hasOwnProperty.call(o, c)) {
          var h = d ? Object.getOwnPropertyDescriptor(o, c) : null;
          h && (h.get || h.set) ? Object.defineProperty(s, c, h) : s[c] = o[c];
        }
      return s.default = o, u && u.set(o, s), s;
    }
    function i(o) {
      if ((() => {
        if (o.purge || !o.content || !Array.isArray(o.content) && !(typeof o.content == "object" && o.content !== null))
          return !1;
        if (Array.isArray(o.content))
          return o.content.every((s) => typeof s == "string" ? !0 : !(typeof s?.raw != "string" || s?.extension && typeof s?.extension != "string"));
        if (typeof o.content == "object" && o.content !== null) {
          if (Object.keys(o.content).some((s) => ![
            "files",
            "relative",
            "extract",
            "transform"
          ].includes(s)))
            return !1;
          if (Array.isArray(o.content.files)) {
            if (!o.content.files.every((s) => typeof s == "string" ? !0 : !(typeof s?.raw != "string" || s?.extension && typeof s?.extension != "string")))
              return !1;
            if (typeof o.content.extract == "object") {
              for (let s of Object.values(o.content.extract))
                if (typeof s != "function")
                  return !1;
            } else if (!(o.content.extract === void 0 || typeof o.content.extract == "function"))
              return !1;
            if (typeof o.content.transform == "object") {
              for (let s of Object.values(o.content.transform))
                if (typeof s != "function")
                  return !1;
            } else if (!(o.content.transform === void 0 || typeof o.content.transform == "function"))
              return !1;
            if (typeof o.content.relative != "boolean" && typeof o.content.relative < "u")
              return !1;
          }
          return !0;
        }
        return !1;
      })() || n.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
      ]), o.safelist = (() => {
        var s;
        let { content: d, purge: c, safelist: h } = o;
        return Array.isArray(h) ? h : Array.isArray(d?.safelist) ? d.safelist : Array.isArray(c?.safelist) ? c.safelist : Array.isArray(c == null || (s = c.options) === null || s === void 0 ? void 0 : s.safelist) ? c.options.safelist : [];
      })(), o.blocklist = (() => {
        let { blocklist: s } = o;
        if (Array.isArray(s)) {
          if (s.every((d) => typeof d == "string"))
            return s;
          n.default.warn("blocklist-invalid", [
            "The `blocklist` option must be an array of strings.",
            "https://tailwindcss.com/docs/content-configuration#discarding-classes"
          ]);
        }
        return [];
      })(), typeof o.prefix == "function")
        n.default.warn("prefix-function", [
          "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
          "Update `prefix` in your configuration to be a string to eliminate this warning.",
          "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]), o.prefix = "";
      else {
        var u;
        o.prefix = (u = o.prefix) !== null && u !== void 0 ? u : "";
      }
      o.content = {
        relative: (() => {
          let { content: s } = o;
          return s?.relative ? s.relative : (0, t.flagEnabled)(o, "relativeContentPathsByDefault");
        })(),
        files: (() => {
          let { content: s, purge: d } = o;
          return Array.isArray(d) ? d : Array.isArray(d?.content) ? d.content : Array.isArray(s) ? s : Array.isArray(s?.content) ? s.content : Array.isArray(s?.files) ? s.files : [];
        })(),
        extract: (() => {
          let s = (() => {
            var h, m, f, M, S, F, L, _, D, q;
            return !((h = o.purge) === null || h === void 0) && h.extract ? o.purge.extract : !((m = o.content) === null || m === void 0) && m.extract ? o.content.extract : !((f = o.purge) === null || f === void 0 || (M = f.extract) === null || M === void 0) && M.DEFAULT ? o.purge.extract.DEFAULT : !((S = o.content) === null || S === void 0 || (F = S.extract) === null || F === void 0) && F.DEFAULT ? o.content.extract.DEFAULT : !((L = o.purge) === null || L === void 0 || (_ = L.options) === null || _ === void 0) && _.extractors ? o.purge.options.extractors : !((D = o.content) === null || D === void 0 || (q = D.options) === null || q === void 0) && q.extractors ? o.content.options.extractors : {};
          })(), d = {}, c = (() => {
            var h, m, f, M;
            if (!((h = o.purge) === null || h === void 0 || (m = h.options) === null || m === void 0) && m.defaultExtractor)
              return o.purge.options.defaultExtractor;
            if (!((f = o.content) === null || f === void 0 || (M = f.options) === null || M === void 0) && M.defaultExtractor)
              return o.content.options.defaultExtractor;
          })();
          if (c !== void 0 && (d.DEFAULT = c), typeof s == "function")
            d.DEFAULT = s;
          else if (Array.isArray(s))
            for (let { extensions: h, extractor: m } of s ?? [])
              for (let f of h)
                d[f] = m;
          else typeof s == "object" && s !== null && Object.assign(d, s);
          return d;
        })(),
        transform: (() => {
          let s = (() => {
            var c, h, m, f, M, S;
            return !((c = o.purge) === null || c === void 0) && c.transform ? o.purge.transform : !((h = o.content) === null || h === void 0) && h.transform ? o.content.transform : !((m = o.purge) === null || m === void 0 || (f = m.transform) === null || f === void 0) && f.DEFAULT ? o.purge.transform.DEFAULT : !((M = o.content) === null || M === void 0 || (S = M.transform) === null || S === void 0) && S.DEFAULT ? o.content.transform.DEFAULT : {};
          })(), d = {};
          return typeof s == "function" ? d.DEFAULT = s : typeof s == "object" && s !== null && Object.assign(d, s), d;
        })()
      };
      for (let s of o.content.files)
        if (typeof s == "string" && /{([^,]*?)}/g.test(s)) {
          n.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, n.dim)(s)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, n.dim)(s.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
          ]);
          break;
        }
      return o;
    }
  }(Me)), Me;
}
var Ce = {}, ct;
function xn() {
  return ct || (ct = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      if (Object.prototype.toString.call(n) !== "[object Object]")
        return !1;
      const r = Object.getPrototypeOf(n);
      return r === null || Object.getPrototypeOf(r) === null;
    }
  }(Ce)), Ce;
}
var Se = {}, ft;
function Pn() {
  return ft || (ft = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return Array.isArray(n) ? n.map((r) => t(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, a]) => [
        r,
        t(a)
      ])) : n;
    }
  }(Se)), Se;
}
var je = {}, $e = {}, mt;
function kn() {
  return mt || (mt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return n.replace(/\\,/g, "\\2c ");
    }
  }($e)), $e;
}
var Ee = {}, Ae = {}, _e = {}, pt;
function On() {
  return pt || (pt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const t = {
      aliceblue: [
        240,
        248,
        255
      ],
      antiquewhite: [
        250,
        235,
        215
      ],
      aqua: [
        0,
        255,
        255
      ],
      aquamarine: [
        127,
        255,
        212
      ],
      azure: [
        240,
        255,
        255
      ],
      beige: [
        245,
        245,
        220
      ],
      bisque: [
        255,
        228,
        196
      ],
      black: [
        0,
        0,
        0
      ],
      blanchedalmond: [
        255,
        235,
        205
      ],
      blue: [
        0,
        0,
        255
      ],
      blueviolet: [
        138,
        43,
        226
      ],
      brown: [
        165,
        42,
        42
      ],
      burlywood: [
        222,
        184,
        135
      ],
      cadetblue: [
        95,
        158,
        160
      ],
      chartreuse: [
        127,
        255,
        0
      ],
      chocolate: [
        210,
        105,
        30
      ],
      coral: [
        255,
        127,
        80
      ],
      cornflowerblue: [
        100,
        149,
        237
      ],
      cornsilk: [
        255,
        248,
        220
      ],
      crimson: [
        220,
        20,
        60
      ],
      cyan: [
        0,
        255,
        255
      ],
      darkblue: [
        0,
        0,
        139
      ],
      darkcyan: [
        0,
        139,
        139
      ],
      darkgoldenrod: [
        184,
        134,
        11
      ],
      darkgray: [
        169,
        169,
        169
      ],
      darkgreen: [
        0,
        100,
        0
      ],
      darkgrey: [
        169,
        169,
        169
      ],
      darkkhaki: [
        189,
        183,
        107
      ],
      darkmagenta: [
        139,
        0,
        139
      ],
      darkolivegreen: [
        85,
        107,
        47
      ],
      darkorange: [
        255,
        140,
        0
      ],
      darkorchid: [
        153,
        50,
        204
      ],
      darkred: [
        139,
        0,
        0
      ],
      darksalmon: [
        233,
        150,
        122
      ],
      darkseagreen: [
        143,
        188,
        143
      ],
      darkslateblue: [
        72,
        61,
        139
      ],
      darkslategray: [
        47,
        79,
        79
      ],
      darkslategrey: [
        47,
        79,
        79
      ],
      darkturquoise: [
        0,
        206,
        209
      ],
      darkviolet: [
        148,
        0,
        211
      ],
      deeppink: [
        255,
        20,
        147
      ],
      deepskyblue: [
        0,
        191,
        255
      ],
      dimgray: [
        105,
        105,
        105
      ],
      dimgrey: [
        105,
        105,
        105
      ],
      dodgerblue: [
        30,
        144,
        255
      ],
      firebrick: [
        178,
        34,
        34
      ],
      floralwhite: [
        255,
        250,
        240
      ],
      forestgreen: [
        34,
        139,
        34
      ],
      fuchsia: [
        255,
        0,
        255
      ],
      gainsboro: [
        220,
        220,
        220
      ],
      ghostwhite: [
        248,
        248,
        255
      ],
      gold: [
        255,
        215,
        0
      ],
      goldenrod: [
        218,
        165,
        32
      ],
      gray: [
        128,
        128,
        128
      ],
      green: [
        0,
        128,
        0
      ],
      greenyellow: [
        173,
        255,
        47
      ],
      grey: [
        128,
        128,
        128
      ],
      honeydew: [
        240,
        255,
        240
      ],
      hotpink: [
        255,
        105,
        180
      ],
      indianred: [
        205,
        92,
        92
      ],
      indigo: [
        75,
        0,
        130
      ],
      ivory: [
        255,
        255,
        240
      ],
      khaki: [
        240,
        230,
        140
      ],
      lavender: [
        230,
        230,
        250
      ],
      lavenderblush: [
        255,
        240,
        245
      ],
      lawngreen: [
        124,
        252,
        0
      ],
      lemonchiffon: [
        255,
        250,
        205
      ],
      lightblue: [
        173,
        216,
        230
      ],
      lightcoral: [
        240,
        128,
        128
      ],
      lightcyan: [
        224,
        255,
        255
      ],
      lightgoldenrodyellow: [
        250,
        250,
        210
      ],
      lightgray: [
        211,
        211,
        211
      ],
      lightgreen: [
        144,
        238,
        144
      ],
      lightgrey: [
        211,
        211,
        211
      ],
      lightpink: [
        255,
        182,
        193
      ],
      lightsalmon: [
        255,
        160,
        122
      ],
      lightseagreen: [
        32,
        178,
        170
      ],
      lightskyblue: [
        135,
        206,
        250
      ],
      lightslategray: [
        119,
        136,
        153
      ],
      lightslategrey: [
        119,
        136,
        153
      ],
      lightsteelblue: [
        176,
        196,
        222
      ],
      lightyellow: [
        255,
        255,
        224
      ],
      lime: [
        0,
        255,
        0
      ],
      limegreen: [
        50,
        205,
        50
      ],
      linen: [
        250,
        240,
        230
      ],
      magenta: [
        255,
        0,
        255
      ],
      maroon: [
        128,
        0,
        0
      ],
      mediumaquamarine: [
        102,
        205,
        170
      ],
      mediumblue: [
        0,
        0,
        205
      ],
      mediumorchid: [
        186,
        85,
        211
      ],
      mediumpurple: [
        147,
        112,
        219
      ],
      mediumseagreen: [
        60,
        179,
        113
      ],
      mediumslateblue: [
        123,
        104,
        238
      ],
      mediumspringgreen: [
        0,
        250,
        154
      ],
      mediumturquoise: [
        72,
        209,
        204
      ],
      mediumvioletred: [
        199,
        21,
        133
      ],
      midnightblue: [
        25,
        25,
        112
      ],
      mintcream: [
        245,
        255,
        250
      ],
      mistyrose: [
        255,
        228,
        225
      ],
      moccasin: [
        255,
        228,
        181
      ],
      navajowhite: [
        255,
        222,
        173
      ],
      navy: [
        0,
        0,
        128
      ],
      oldlace: [
        253,
        245,
        230
      ],
      olive: [
        128,
        128,
        0
      ],
      olivedrab: [
        107,
        142,
        35
      ],
      orange: [
        255,
        165,
        0
      ],
      orangered: [
        255,
        69,
        0
      ],
      orchid: [
        218,
        112,
        214
      ],
      palegoldenrod: [
        238,
        232,
        170
      ],
      palegreen: [
        152,
        251,
        152
      ],
      paleturquoise: [
        175,
        238,
        238
      ],
      palevioletred: [
        219,
        112,
        147
      ],
      papayawhip: [
        255,
        239,
        213
      ],
      peachpuff: [
        255,
        218,
        185
      ],
      peru: [
        205,
        133,
        63
      ],
      pink: [
        255,
        192,
        203
      ],
      plum: [
        221,
        160,
        221
      ],
      powderblue: [
        176,
        224,
        230
      ],
      purple: [
        128,
        0,
        128
      ],
      rebeccapurple: [
        102,
        51,
        153
      ],
      red: [
        255,
        0,
        0
      ],
      rosybrown: [
        188,
        143,
        143
      ],
      royalblue: [
        65,
        105,
        225
      ],
      saddlebrown: [
        139,
        69,
        19
      ],
      salmon: [
        250,
        128,
        114
      ],
      sandybrown: [
        244,
        164,
        96
      ],
      seagreen: [
        46,
        139,
        87
      ],
      seashell: [
        255,
        245,
        238
      ],
      sienna: [
        160,
        82,
        45
      ],
      silver: [
        192,
        192,
        192
      ],
      skyblue: [
        135,
        206,
        235
      ],
      slateblue: [
        106,
        90,
        205
      ],
      slategray: [
        112,
        128,
        144
      ],
      slategrey: [
        112,
        128,
        144
      ],
      snow: [
        255,
        250,
        250
      ],
      springgreen: [
        0,
        255,
        127
      ],
      steelblue: [
        70,
        130,
        180
      ],
      tan: [
        210,
        180,
        140
      ],
      teal: [
        0,
        128,
        128
      ],
      thistle: [
        216,
        191,
        216
      ],
      tomato: [
        255,
        99,
        71
      ],
      turquoise: [
        64,
        224,
        208
      ],
      violet: [
        238,
        130,
        238
      ],
      wheat: [
        245,
        222,
        179
      ],
      white: [
        255,
        255,
        255
      ],
      whitesmoke: [
        245,
        245,
        245
      ],
      yellow: [
        255,
        255,
        0
      ],
      yellowgreen: [
        154,
        205,
        50
      ]
    };
  }(_e)), _e;
}
var ht;
function Nt() {
  return ht || (ht = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(f, M) {
      for (var S in M) Object.defineProperty(f, S, {
        enumerable: !0,
        get: M[S]
      });
    }
    t(e, {
      parseColor: function() {
        return h;
      },
      formatColor: function() {
        return m;
      }
    });
    const n = /* @__PURE__ */ r(On());
    function r(f) {
      return f && f.__esModule ? f : {
        default: f
      };
    }
    let a = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, i = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, o = /(?:\d+|\d*\.\d+)%?/, l = /(?:\s*,\s*|\s+)/, u = /\s*[,/]\s*/, s = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, d = new RegExp(`^(rgba?)\\(\\s*(${o.source}|${s.source})(?:${l.source}(${o.source}|${s.source}))?(?:${l.source}(${o.source}|${s.source}))?(?:${u.source}(${o.source}|${s.source}))?\\s*\\)$`), c = new RegExp(`^(hsla?)\\(\\s*((?:${o.source})(?:deg|rad|grad|turn)?|${s.source})(?:${l.source}(${o.source}|${s.source}))?(?:${l.source}(${o.source}|${s.source}))?(?:${u.source}(${o.source}|${s.source}))?\\s*\\)$`);
    function h(f, { loose: M = !1 } = {}) {
      var S, F;
      if (typeof f != "string")
        return null;
      if (f = f.trim(), f === "transparent")
        return {
          mode: "rgb",
          color: [
            "0",
            "0",
            "0"
          ],
          alpha: "0"
        };
      if (f in n.default)
        return {
          mode: "rgb",
          color: n.default[f].map((V) => V.toString())
        };
      let L = f.replace(i, (V, $, E, b, x) => [
        "#",
        $,
        $,
        E,
        E,
        b,
        b,
        x ? x + x : ""
      ].join("")).match(a);
      if (L !== null)
        return {
          mode: "rgb",
          color: [
            parseInt(L[1], 16),
            parseInt(L[2], 16),
            parseInt(L[3], 16)
          ].map((V) => V.toString()),
          alpha: L[4] ? (parseInt(L[4], 16) / 255).toString() : void 0
        };
      var _;
      let D = (_ = f.match(d)) !== null && _ !== void 0 ? _ : f.match(c);
      if (D === null)
        return null;
      let q = [
        D[2],
        D[3],
        D[4]
      ].filter(Boolean).map((V) => V.toString());
      return q.length === 2 && q[0].startsWith("var(") ? {
        mode: D[1],
        color: [
          q[0]
        ],
        alpha: q[1]
      } : !M && q.length !== 3 || q.length < 3 && !q.some((V) => /^var\(.*?\)$/.test(V)) ? null : {
        mode: D[1],
        color: q,
        alpha: (S = D[5]) === null || S === void 0 || (F = S.toString) === null || F === void 0 ? void 0 : F.call(S)
      };
    }
    function m({ mode: f, color: M, alpha: S }) {
      let F = S !== void 0;
      return f === "rgba" || f === "hsla" ? `${f}(${M.join(", ")}${F ? `, ${S}` : ""})` : `${f}(${M.join(" ")}${F ? ` / ${S}` : ""})`;
    }
  }(Ae)), Ae;
}
var gt;
function Bt() {
  return gt || (gt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, o) {
      for (var l in o) Object.defineProperty(i, l, {
        enumerable: !0,
        get: o[l]
      });
    }
    t(e, {
      withAlphaValue: function() {
        return r;
      },
      default: function() {
        return a;
      }
    });
    const n = Nt();
    function r(i, o, l) {
      if (typeof i == "function")
        return i({
          opacityValue: o
        });
      let u = (0, n.parseColor)(i, {
        loose: !0
      });
      return u === null ? l : (0, n.formatColor)({
        ...u,
        alpha: o
      });
    }
    function a({ color: i, property: o, variable: l }) {
      let u = [].concat(o);
      if (typeof i == "function")
        return {
          [l]: "1",
          ...Object.fromEntries(u.map((d) => [
            d,
            i({
              opacityVariable: l,
              opacityValue: `var(${l}, 1)`
            })
          ]))
        };
      const s = (0, n.parseColor)(i);
      return s === null ? Object.fromEntries(u.map((d) => [
        d,
        i
      ])) : s.alpha !== void 0 ? Object.fromEntries(u.map((d) => [
        d,
        i
      ])) : {
        [l]: "1",
        ...Object.fromEntries(u.map((d) => [
          d,
          (0, n.formatColor)({
            ...s,
            alpha: `var(${l}, 1)`
          })
        ]))
      };
    }
  }(Ee)), Ee;
}
var De = {}, ze = {}, Te = {}, bt;
function Ze() {
  return bt || (bt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "splitAtTopLevelOnly", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n, r) {
      let a = [], i = [], o = 0, l = !1;
      for (let u = 0; u < n.length; u++) {
        let s = n[u];
        a.length === 0 && s === r[0] && !l && (r.length === 1 || n.slice(u, u + r.length) === r) && (i.push(n.slice(o, u)), o = u + r.length), l = l ? !1 : s === "\\", s === "(" || s === "[" || s === "{" ? a.push(s) : (s === ")" && a[a.length - 1] === "(" || s === "]" && a[a.length - 1] === "[" || s === "}" && a[a.length - 1] === "{") && a.pop();
      }
      return i.push(n.slice(o)), i;
    }
  }(Te)), Te;
}
var vt;
function Mn() {
  return vt || (vt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(u, s) {
      for (var d in s) Object.defineProperty(u, d, {
        enumerable: !0,
        get: s[d]
      });
    }
    t(e, {
      parseBoxShadowValue: function() {
        return o;
      },
      formatBoxShadowValue: function() {
        return l;
      }
    });
    const n = Ze();
    let r = /* @__PURE__ */ new Set([
      "inset",
      "inherit",
      "initial",
      "revert",
      "unset"
    ]), a = /\ +(?![^(]*\))/g, i = /^-?(\d+|\.\d+)(.*?)$/g;
    function o(u) {
      return (0, n.splitAtTopLevelOnly)(u, ",").map((d) => {
        let c = d.trim(), h = {
          raw: c
        }, m = c.split(a), f = /* @__PURE__ */ new Set();
        for (let M of m)
          i.lastIndex = 0, !f.has("KEYWORD") && r.has(M) ? (h.keyword = M, f.add("KEYWORD")) : i.test(M) ? f.has("X") ? f.has("Y") ? f.has("BLUR") ? f.has("SPREAD") || (h.spread = M, f.add("SPREAD")) : (h.blur = M, f.add("BLUR")) : (h.y = M, f.add("Y")) : (h.x = M, f.add("X")) : h.color ? (h.unknown || (h.unknown = []), h.unknown.push(M)) : h.color = M;
        return h.valid = h.x !== void 0 && h.y !== void 0, h;
      });
    }
    function l(u) {
      return u.map((s) => s.valid ? [
        s.keyword,
        s.x,
        s.y,
        s.blur,
        s.spread,
        s.color
      ].filter(Boolean).join(" ") : s.raw).join(", ");
    }
  }(ze)), ze;
}
var yt;
function Ut() {
  return yt || (yt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(g, k) {
      for (var C in k) Object.defineProperty(g, C, {
        enumerable: !0,
        get: k[C]
      });
    }
    t(e, {
      normalize: function() {
        return u;
      },
      normalizeAttributeSelectors: function() {
        return s;
      },
      url: function() {
        return c;
      },
      number: function() {
        return h;
      },
      percentage: function() {
        return m;
      },
      length: function() {
        return S;
      },
      lineWidth: function() {
        return L;
      },
      shadow: function() {
        return _;
      },
      color: function() {
        return D;
      },
      image: function() {
        return q;
      },
      gradient: function() {
        return $;
      },
      position: function() {
        return b;
      },
      familyName: function() {
        return x;
      },
      genericName: function() {
        return p;
      },
      absoluteSize: function() {
        return O;
      },
      relativeSize: function() {
        return W;
      }
    });
    const n = Nt(), r = Mn(), a = Ze();
    let i = [
      "min",
      "max",
      "clamp",
      "calc"
    ];
    function o(g) {
      return i.some((k) => new RegExp(`^${k}\\(.*\\)`).test(g));
    }
    const l = /* @__PURE__ */ new Set([
      // Concrete properties
      "scroll-timeline-name",
      "timeline-scope",
      "view-timeline-name",
      "font-palette",
      "anchor-name",
      "anchor-scope",
      "position-anchor",
      "position-try-options",
      // Shorthand properties
      "scroll-timeline",
      "animation-timeline",
      "view-timeline",
      "position-try"
    ]);
    function u(g, k = null, C = !0) {
      let w = k && l.has(k.property);
      return g.startsWith("--") && !w ? `var(${g})` : g.includes("url(") ? g.split(/(url\(.*?\))/g).filter(Boolean).map((j) => /^url\(.*?\)$/.test(j) ? j : u(j, k, !1)).join("") : (g = g.replace(/([^\\])_+/g, (j, B) => B + " ".repeat(j.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), C && (g = g.trim()), g = d(g), g);
    }
    function s(g) {
      return g.includes("=") && (g = g.replace(/(=.*)/g, (k, C) => {
        if (C[1] === "'" || C[1] === '"')
          return C;
        if (C.length > 2) {
          let w = C[C.length - 1];
          if (C[C.length - 2] === " " && (w === "i" || w === "I" || w === "s" || w === "S"))
            return `="${C.slice(1, -2)}" ${C[C.length - 1]}`;
        }
        return `="${C.slice(1)}"`;
      })), g;
    }
    function d(g) {
      let k = [
        "theme"
      ], C = [
        "min-content",
        "max-content",
        "fit-content",
        // Env
        "safe-area-inset-top",
        "safe-area-inset-right",
        "safe-area-inset-bottom",
        "safe-area-inset-left",
        "titlebar-area-x",
        "titlebar-area-y",
        "titlebar-area-width",
        "titlebar-area-height",
        "keyboard-inset-top",
        "keyboard-inset-right",
        "keyboard-inset-bottom",
        "keyboard-inset-left",
        "keyboard-inset-width",
        "keyboard-inset-height",
        "radial-gradient",
        "linear-gradient",
        "conic-gradient",
        "repeating-radial-gradient",
        "repeating-linear-gradient",
        "repeating-conic-gradient",
        "anchor-size"
      ];
      return g.replace(/(calc|min|max|clamp)\(.+\)/g, (w) => {
        let j = "";
        function B() {
          let R = j.trimEnd();
          return R[R.length - 1];
        }
        for (let R = 0; R < w.length; R++) {
          let U = function(I) {
            return I.split("").every((K, le) => w[R + le] === K);
          }, H = function(I) {
            let K = 1 / 0;
            for (let an of I) {
              let he = w.indexOf(an, R);
              he !== -1 && he < K && (K = he);
            }
            let le = w.slice(R, K);
            return R += le.length - 1, le;
          }, G = w[R];
          if (U("var"))
            j += H([
              ")",
              ","
            ]);
          else if (C.some((I) => U(I))) {
            let I = C.find((K) => U(K));
            j += I, R += I.length - 1;
          } else k.some((I) => U(I)) ? j += H([
            ")"
          ]) : U("[") ? j += H([
            "]"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(G) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(B()) ? j += ` ${G} ` : j += G;
        }
        return j.replace(/\s+/g, " ");
      });
    }
    function c(g) {
      return g.startsWith("url(");
    }
    function h(g) {
      return !isNaN(Number(g)) || o(g);
    }
    function m(g) {
      return g.endsWith("%") && h(g.slice(0, -1)) || o(g);
    }
    let M = `(?:${[
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px",
      "em",
      "ex",
      "ch",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vmin",
      "vmax",
      "vb",
      "vi",
      "svw",
      "svh",
      "lvw",
      "lvh",
      "dvw",
      "dvh",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ].join("|")})`;
    function S(g) {
      return g === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${M}$`).test(g) || o(g);
    }
    let F = /* @__PURE__ */ new Set([
      "thin",
      "medium",
      "thick"
    ]);
    function L(g) {
      return F.has(g);
    }
    function _(g) {
      let k = (0, r.parseBoxShadowValue)(u(g));
      for (let C of k)
        if (!C.valid)
          return !1;
      return !0;
    }
    function D(g) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(g, "_").every((w) => (w = u(w), w.startsWith("var(") ? !0 : (0, n.parseColor)(w, {
        loose: !0
      }) !== null ? (k++, !0) : !1)) ? k > 0 : !1;
    }
    function q(g) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(g, ",").every((w) => (w = u(w), w.startsWith("var(") ? !0 : c(w) || $(w) || [
        "element(",
        "image(",
        "cross-fade(",
        "image-set("
      ].some((j) => w.startsWith(j)) ? (k++, !0) : !1)) ? k > 0 : !1;
    }
    let V = /* @__PURE__ */ new Set([
      "conic-gradient",
      "linear-gradient",
      "radial-gradient",
      "repeating-conic-gradient",
      "repeating-linear-gradient",
      "repeating-radial-gradient"
    ]);
    function $(g) {
      g = u(g);
      for (let k of V)
        if (g.startsWith(`${k}(`))
          return !0;
      return !1;
    }
    let E = /* @__PURE__ */ new Set([
      "center",
      "top",
      "right",
      "bottom",
      "left"
    ]);
    function b(g) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(g, "_").every((w) => (w = u(w), w.startsWith("var(") ? !0 : E.has(w) || S(w) || m(w) ? (k++, !0) : !1)) ? k > 0 : !1;
    }
    function x(g) {
      let k = 0;
      return (0, a.splitAtTopLevelOnly)(g, ",").every((w) => (w = u(w), w.startsWith("var(") ? !0 : w.includes(" ") && !/(['"])([^"']+)\1/g.test(w) || /^\d/g.test(w) ? !1 : (k++, !0))) ? k > 0 : !1;
    }
    let P = /* @__PURE__ */ new Set([
      "serif",
      "sans-serif",
      "monospace",
      "cursive",
      "fantasy",
      "system-ui",
      "ui-serif",
      "ui-sans-serif",
      "ui-monospace",
      "ui-rounded",
      "math",
      "emoji",
      "fangsong"
    ]);
    function p(g) {
      return P.has(g);
    }
    let y = /* @__PURE__ */ new Set([
      "xx-small",
      "x-small",
      "small",
      "medium",
      "large",
      "x-large",
      "xx-large",
      "xxx-large"
    ]);
    function O(g) {
      return y.has(g);
    }
    let v = /* @__PURE__ */ new Set([
      "larger",
      "smaller"
    ]);
    function W(g) {
      return v.has(g);
    }
  }(De)), De;
}
var Fe = {}, wt;
function Wn() {
  return wt || (wt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "backgroundSize", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const t = Ut(), n = Ze();
    function r(a) {
      let i = [
        "cover",
        "contain"
      ];
      return (0, n.splitAtTopLevelOnly)(a, ",").every((o) => {
        let l = (0, n.splitAtTopLevelOnly)(o, "_").filter(Boolean);
        return l.length === 1 && i.includes(l[0]) ? !0 : l.length !== 1 && l.length !== 2 ? !1 : l.every((u) => (0, t.length)(u) || (0, t.percentage)(u) || u === "auto");
      });
    }
  }(Fe)), Fe;
}
var xt;
function Cn() {
  return xt || (xt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(b, x) {
      for (var P in x) Object.defineProperty(b, P, {
        enumerable: !0,
        get: x[P]
      });
    }
    t(e, {
      updateAllClasses: function() {
        return s;
      },
      asValue: function() {
        return h;
      },
      parseColorFormat: function() {
        return M;
      },
      asColor: function() {
        return F;
      },
      asLookupValue: function() {
        return L;
      },
      typeMap: function() {
        return D;
      },
      coerceValue: function() {
        return $;
      },
      getMatchingTypes: function() {
        return E;
      }
    });
    const n = /* @__PURE__ */ u(kn()), r = Bt(), a = Ut(), i = /* @__PURE__ */ u(Ht()), o = Wn(), l = Je();
    function u(b) {
      return b && b.__esModule ? b : {
        default: b
      };
    }
    function s(b, x) {
      b.walkClasses((P) => {
        P.value = x(P.value), P.raws && P.raws.value && (P.raws.value = (0, n.default)(P.raws.value));
      });
    }
    function d(b, x) {
      if (!m(b))
        return;
      let P = b.slice(1, -1);
      if (x(P))
        return (0, a.normalize)(P);
    }
    function c(b, x = {}, P) {
      let p = x[b];
      if (p !== void 0)
        return (0, i.default)(p);
      if (m(b)) {
        let y = d(b, P);
        return y === void 0 ? void 0 : (0, i.default)(y);
      }
    }
    function h(b, x = {}, { validate: P = () => !0 } = {}) {
      var p;
      let y = (p = x.values) === null || p === void 0 ? void 0 : p[b];
      return y !== void 0 ? y : x.supportsNegativeValues && b.startsWith("-") ? c(b.slice(1), x.values, P) : d(b, P);
    }
    function m(b) {
      return b.startsWith("[") && b.endsWith("]");
    }
    function f(b) {
      let x = b.lastIndexOf("/"), P = b.lastIndexOf("[", x), p = b.indexOf("]", x);
      return b[x - 1] === "]" || b[x + 1] === "[" || P !== -1 && p !== -1 && P < x && x < p && (x = b.lastIndexOf("/", P)), x === -1 || x === b.length - 1 ? [
        b,
        void 0
      ] : m(b) && !b.includes("]/[") ? [
        b,
        void 0
      ] : [
        b.slice(0, x),
        b.slice(x + 1)
      ];
    }
    function M(b) {
      if (typeof b == "string" && b.includes("<alpha-value>")) {
        let x = b;
        return ({ opacityValue: P = 1 }) => x.replace(/<alpha-value>/g, P);
      }
      return b;
    }
    function S(b) {
      return (0, a.normalize)(b.slice(1, -1));
    }
    function F(b, x = {}, { tailwindConfig: P = {} } = {}) {
      var p;
      if (((p = x.values) === null || p === void 0 ? void 0 : p[b]) !== void 0) {
        var y;
        return M((y = x.values) === null || y === void 0 ? void 0 : y[b]);
      }
      let [O, v] = f(b);
      if (v !== void 0) {
        var W, g, k, C;
        let w = (C = (W = x.values) === null || W === void 0 ? void 0 : W[O]) !== null && C !== void 0 ? C : m(O) ? O.slice(1, -1) : void 0;
        return w === void 0 ? void 0 : (w = M(w), m(v) ? (0, r.withAlphaValue)(w, S(v)) : ((g = P.theme) === null || g === void 0 || (k = g.opacity) === null || k === void 0 ? void 0 : k[v]) === void 0 ? void 0 : (0, r.withAlphaValue)(w, P.theme.opacity[v]));
      }
      return h(b, x, {
        validate: a.color
      });
    }
    function L(b, x = {}) {
      var P;
      return (P = x.values) === null || P === void 0 ? void 0 : P[b];
    }
    function _(b) {
      return (x, P) => h(x, P, {
        validate: b
      });
    }
    let D = {
      any: h,
      color: F,
      url: _(a.url),
      image: _(a.image),
      length: _(a.length),
      percentage: _(a.percentage),
      position: _(a.position),
      lookup: L,
      "generic-name": _(a.genericName),
      "family-name": _(a.familyName),
      number: _(a.number),
      "line-width": _(a.lineWidth),
      "absolute-size": _(a.absoluteSize),
      "relative-size": _(a.relativeSize),
      shadow: _(a.shadow),
      size: _(o.backgroundSize)
    }, q = Object.keys(D);
    function V(b, x) {
      let P = b.indexOf(x);
      return P === -1 ? [
        void 0,
        b
      ] : [
        b.slice(0, P),
        b.slice(P + 1)
      ];
    }
    function $(b, x, P, p) {
      if (P.values && x in P.values)
        for (let { type: O } of b ?? []) {
          let v = D[O](x, P, {
            tailwindConfig: p
          });
          if (v !== void 0)
            return [
              v,
              O,
              null
            ];
        }
      if (m(x)) {
        let O = x.slice(1, -1), [v, W] = V(O, ":");
        if (!/^[\w-_]+$/g.test(v))
          W = O;
        else if (v !== void 0 && !q.includes(v))
          return [];
        if (W.length > 0 && q.includes(v))
          return [
            h(`[${W}]`, P),
            v,
            null
          ];
      }
      let y = E(b, x, P, p);
      for (let O of y)
        return O;
      return [];
    }
    function* E(b, x, P, p) {
      let y = (0, l.flagEnabled)(p, "generalizedModifiers"), [O, v] = f(x);
      if (y && P.modifiers != null && (P.modifiers === "any" || typeof P.modifiers == "object" && (v && m(v) || v in P.modifiers)) || (O = x, v = void 0), v !== void 0 && O === "" && (O = "DEFAULT"), v !== void 0 && typeof P.modifiers == "object") {
        var g, k;
        let C = (k = (g = P.modifiers) === null || g === void 0 ? void 0 : g[v]) !== null && k !== void 0 ? k : null;
        C !== null ? v = C : m(v) && (v = S(v));
      }
      for (let { type: C } of b ?? []) {
        let w = D[C](O, P, {
          tailwindConfig: p
        });
        w !== void 0 && (yield [
          w,
          C,
          v ?? null
        ]);
      }
    }
  }(je)), je;
}
var Le = {}, Pt;
function Sn() {
  return Pt || (Pt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return typeof n == "function" ? n({}) : n;
    }
  }(Le)), Le;
}
var kt;
function jn() {
  return kt || (kt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return P;
      }
    });
    const t = /* @__PURE__ */ m(Ht()), n = /* @__PURE__ */ m(hn()), r = /* @__PURE__ */ m(gn()), a = /* @__PURE__ */ m(bn()), i = vn(), o = yn(), l = wn(), u = /* @__PURE__ */ m(xn()), s = Pn(), d = Cn(), c = Bt(), h = /* @__PURE__ */ m(Sn());
    function m(p) {
      return p && p.__esModule ? p : {
        default: p
      };
    }
    function f(p) {
      return typeof p == "function";
    }
    function M(p, ...y) {
      let O = y.pop();
      for (let v of y)
        for (let W in v) {
          let g = O(p[W], v[W]);
          g === void 0 ? (0, u.default)(p[W]) && (0, u.default)(v[W]) ? p[W] = M({}, p[W], v[W], O) : p[W] = v[W] : p[W] = g;
        }
      return p;
    }
    const S = {
      colors: a.default,
      negative(p) {
        return Object.keys(p).filter((y) => p[y] !== "0").reduce((y, O) => {
          let v = (0, t.default)(p[O]);
          return v !== void 0 && (y[`-${O}`] = v), y;
        }, {});
      },
      breakpoints(p) {
        return Object.keys(p).filter((y) => typeof p[y] == "string").reduce((y, O) => ({
          ...y,
          [`screen-${O}`]: p[O]
        }), {});
      }
    };
    function F(p, ...y) {
      return f(p) ? p(...y) : p;
    }
    function L(p) {
      return p.reduce((y, { extend: O }) => M(y, O, (v, W) => v === void 0 ? [
        W
      ] : Array.isArray(v) ? [
        W,
        ...v
      ] : [
        W,
        v
      ]), {});
    }
    function _(p) {
      return {
        ...p.reduce((y, O) => (0, i.defaults)(y, O), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: L(p)
      };
    }
    function D(p, y) {
      if (Array.isArray(p) && (0, u.default)(p[0]))
        return p.concat(y);
      if (Array.isArray(y) && (0, u.default)(y[0]) && (0, u.default)(p))
        return [
          p,
          ...y
        ];
      if (Array.isArray(y))
        return y;
    }
    function q({ extend: p, ...y }) {
      return M(y, p, (O, v) => !f(O) && !v.some(f) ? M({}, O, ...v, D) : (W, g) => M({}, ...[
        O,
        ...v
      ].map((k) => F(k, W, g)), D));
    }
    function* V(p) {
      let y = (0, o.toPath)(p);
      if (y.length === 0 || (yield y, Array.isArray(p)))
        return;
      let O = /^(.*?)\s*\/\s*([^/]+)$/, v = p.match(O);
      if (v !== null) {
        let [, W, g] = v, k = (0, o.toPath)(W);
        k.alpha = g, yield k;
      }
    }
    function $(p) {
      const y = (O, v) => {
        for (const W of V(O)) {
          let g = 0, k = p;
          for (; k != null && g < W.length; )
            k = k[W[g++]], k = f(k) && (W.alpha === void 0 || g <= W.length - 1) ? k(y, S) : k;
          if (k !== void 0) {
            if (W.alpha !== void 0) {
              let C = (0, d.parseColorFormat)(k);
              return (0, c.withAlphaValue)(C, W.alpha, (0, h.default)(C));
            }
            return (0, u.default)(k) ? (0, s.cloneDeep)(k) : k;
          }
        }
        return v;
      };
      return Object.assign(y, {
        theme: y,
        ...S
      }), Object.keys(p).reduce((O, v) => (O[v] = f(p[v]) ? p[v](y, S) : p[v], O), {});
    }
    function E(p) {
      let y = [];
      return p.forEach((O) => {
        y = [
          ...y,
          O
        ];
        var v;
        const W = (v = O?.plugins) !== null && v !== void 0 ? v : [];
        W.length !== 0 && W.forEach((g) => {
          g.__isOptionsFunction && (g = g());
          var k;
          y = [
            ...y,
            ...E([
              (k = g?.config) !== null && k !== void 0 ? k : {}
            ])
          ];
        });
      }), y;
    }
    function b(p) {
      return [
        ...p
      ].reduceRight((O, v) => f(v) ? v({
        corePlugins: O
      }) : (0, r.default)(v, O), n.default);
    }
    function x(p) {
      return [
        ...p
      ].reduceRight((O, v) => [
        ...O,
        ...v
      ], []);
    }
    function P(p) {
      let y = [
        ...E(p),
        {
          prefix: "",
          important: !1,
          separator: ":"
        }
      ];
      var O, v;
      return (0, l.normalizeConfig)((0, i.defaults)({
        theme: $(q(_(y.map((W) => (O = W?.theme) !== null && O !== void 0 ? O : {})))),
        corePlugins: b(y.map((W) => W.corePlugins)),
        plugins: x(p.map((W) => (v = W?.plugins) !== null && v !== void 0 ? v : []))
      }, ...y));
    }
  }(be)), be;
}
var qe = {}, Re, Ot;
function $n() {
  return Ot || (Ot = 1, Re = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: e }) => ({
        ...e("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: e }) => e("blur"),
      backdropBrightness: ({ theme: e }) => e("brightness"),
      backdropContrast: ({ theme: e }) => e("contrast"),
      backdropGrayscale: ({ theme: e }) => e("grayscale"),
      backdropHueRotate: ({ theme: e }) => e("hueRotate"),
      backdropInvert: ({ theme: e }) => e("invert"),
      backdropOpacity: ({ theme: e }) => e("opacity"),
      backdropSaturate: ({ theme: e }) => e("saturate"),
      backdropSepia: ({ theme: e }) => e("sepia"),
      backgroundColor: ({ theme: e }) => e("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: e }) => e("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: e }) => ({
        ...e("colors"),
        DEFAULT: e("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: e }) => e("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: e }) => ({
        ...e("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: e }) => e("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: e }) => e("colors"),
      colors: ({ colors: e }) => ({
        inherit: e.inherit,
        current: e.current,
        transparent: e.transparent,
        black: e.black,
        white: e.white,
        slate: e.slate,
        gray: e.gray,
        zinc: e.zinc,
        neutral: e.neutral,
        stone: e.stone,
        red: e.red,
        orange: e.orange,
        amber: e.amber,
        yellow: e.yellow,
        lime: e.lime,
        green: e.green,
        emerald: e.emerald,
        teal: e.teal,
        cyan: e.cyan,
        sky: e.sky,
        blue: e.blue,
        indigo: e.indigo,
        violet: e.violet,
        purple: e.purple,
        fuchsia: e.fuchsia,
        pink: e.pink,
        rose: e.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: e }) => e("borderColor"),
      divideOpacity: ({ theme: e }) => e("borderOpacity"),
      divideWidth: ({ theme: e }) => e("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: e }) => e("spacing"),
      gradientColorStops: ({ theme: e }) => e("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: e }) => ({
        ...e("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: e, breakpoints: t }) => ({
        ...e("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...t(e("screens"))
      }),
      minHeight: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: e }) => e("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: e }) => e("spacing"),
      placeholderColor: ({ theme: e }) => e("colors"),
      placeholderOpacity: ({ theme: e }) => e("opacity"),
      ringColor: ({ theme: e }) => ({
        DEFAULT: e("colors.blue.500", "#3b82f6"),
        ...e("colors")
      }),
      ringOffsetColor: ({ theme: e }) => e("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: e }) => ({
        DEFAULT: "0.5",
        ...e("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: e }) => ({
        ...e("spacing")
      }),
      scrollPadding: ({ theme: e }) => e("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: e }) => ({
        ...e("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: e }) => e("colors"),
      textDecorationColor: ({ theme: e }) => e("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: e }) => ({
        ...e("spacing")
      }),
      textOpacity: ({ theme: e }) => e("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: e }) => ({
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), Re;
}
var Mt;
function En() {
  return Mt || (Mt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const t = /* @__PURE__ */ r($n()), n = Je();
    function r(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    function a(i) {
      var o;
      const l = ((o = i?.presets) !== null && o !== void 0 ? o : [
        t.default
      ]).slice().reverse().flatMap((d) => a(d instanceof Function ? d() : d)), u = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: ({ theme: d }) => ({
              DEFAULT: "#3b82f67f",
              ...d("colors")
            })
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      }, s = Object.keys(u).filter((d) => (0, n.flagEnabled)(i, d)).map((d) => u[d]);
      return [
        i,
        ...s,
        ...l
      ];
    }
  }(qe)), qe;
}
var Wt;
function An() {
  return Wt || (Wt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const t = /* @__PURE__ */ r(jn()), n = /* @__PURE__ */ r(En());
    function r(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    function a(...i) {
      let [, ...o] = (0, n.default)(i[0]);
      return (0, t.default)([
        ...i,
        ...o
      ]);
    }
  }(ge)), ge;
}
var Ve, Ct;
function _n() {
  if (Ct) return Ve;
  Ct = 1;
  let e = An();
  return Ve = (e.__esModule ? e : { default: e }).default, Ve;
}
var Dn = _n();
const zn = /* @__PURE__ */ on(Dn), oe = zn(sn), Li = parseInt(oe.theme.screens.md), Tn = {
  sm: parseInt(oe.theme.screens.sm),
  md: parseInt(oe.theme.screens.md),
  lg: parseInt(oe.theme.screens.lg),
  xl: parseInt(oe.theme.screens.xl)
};
function Fn(e) {
  return dn() ? (cn(e), !0) : !1;
}
const He = /* @__PURE__ */ new WeakMap(), Ln = (...e) => {
  var t;
  const n = e[0], r = (t = Qe()) == null ? void 0 : t.proxy;
  if (r == null && !Vt())
    throw new Error("injectLocal must be called in setup");
  return r && He.has(r) && n in He.get(r) ? He.get(r)[n] : ln(...e);
}, qn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Rn = Object.prototype.toString, Vn = (e) => Rn.call(e) === "[object Object]", St = () => {
};
function Yt(e, t) {
  function n(...r) {
    return new Promise((a, i) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(a).catch(i);
    });
  }
  return n;
}
const Hn = (e) => e();
function Xt(e, t = {}) {
  let n, r, a = St;
  const i = (u) => {
    clearTimeout(u), a(), a = St;
  };
  let o;
  return (u) => {
    const s = X(e), d = X(t.maxWait);
    return n && i(n), s <= 0 || d !== void 0 && d <= 0 ? (r && (i(r), r = null), Promise.resolve(u())) : new Promise((c, h) => {
      a = t.rejectOnCancel ? h : c, o = u, d && !r && (r = setTimeout(() => {
        n && i(n), r = null, c(o());
      }, d)), n = setTimeout(() => {
        r && i(r), r = null, c(u());
      }, s);
    });
  };
}
function In(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const r = ((n = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", a = e.slice(r.length), i = Number.parseFloat(r) + t;
  return Number.isNaN(i) ? e : i + a;
}
function ie(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Ie(e) {
  return Array.isArray(e) ? e : [e];
}
function Nn(e) {
  return Qe();
}
function qi(e, t = 200, n = {}) {
  return Yt(
    Xt(t, n),
    e
  );
}
function Bn(e, t, n = {}) {
  const {
    eventFilter: r = Hn,
    ...a
  } = n;
  return Ge(
    e,
    Yt(
      r,
      t
    ),
    a
  );
}
function Gt(e, t = !0, n) {
  Nn() ? Rt(e, n) : t ? e() : un(e);
}
function Ri(e, t, n = {}) {
  const {
    debounce: r = 0,
    maxWait: a = void 0,
    ...i
  } = n;
  return Bn(
    e,
    t,
    {
      ...i,
      eventFilter: Xt(r, { maxWait: a })
    }
  );
}
function Un(e, t, n) {
  return Ge(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const me = qn ? window : void 0;
function Yn(e) {
  var t;
  const n = X(e);
  return (t = n?.$el) != null ? t : n;
}
function Xe(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, r = (l, u, s, d) => (l.addEventListener(u, s, d), () => l.removeEventListener(u, s, d)), a = se(() => {
    const l = Ie(X(e[0])).filter((u) => u != null);
    return l.every((u) => typeof u != "string") ? l : void 0;
  }), i = Un(
    () => {
      var l, u;
      return [
        (u = (l = a.value) == null ? void 0 : l.map((s) => Yn(s))) != null ? u : [me].filter((s) => s != null),
        Ie(X(a.value ? e[1] : e[0])),
        Ie(mn(a.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        X(a.value ? e[3] : e[2])
      ];
    },
    ([l, u, s, d]) => {
      if (n(), !l?.length || !u?.length || !s?.length)
        return;
      const c = Vn(d) ? { ...d } : d;
      t.push(
        ...l.flatMap(
          (h) => u.flatMap(
            (m) => s.map((f) => r(h, m, f, c))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    i(), n();
  };
  return Fn(n), o;
}
function Xn() {
  const e = Z(!1), t = Qe();
  return t && Rt(() => {
    e.value = !0;
  }, t), e;
}
function Gn(e) {
  const t = Xn();
  return se(() => (t.value, !!e()));
}
const Qn = Symbol("vueuse-ssr-width");
function Qt() {
  const e = Vt() ? Ln(Qn, null) : null;
  return typeof e == "number" ? e : void 0;
}
function re(e, t = {}) {
  const { window: n = me, ssrWidth: r = Qt() } = t, a = Gn(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), i = Z(typeof r == "number"), o = Z(), l = Z(!1), u = (s) => {
    l.value = s.matches;
  };
  return fn(() => {
    if (i.value) {
      i.value = !a.value;
      const s = X(e).split(",");
      l.value = s.some((d) => {
        const c = d.includes("not all"), h = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), m = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let f = !!(h || m);
        return h && f && (f = r >= ie(h[1])), m && f && (f = r <= ie(m[1])), c ? !f : f;
      });
      return;
    }
    a.value && (o.value = n.matchMedia(X(e)), l.value = o.value.matches);
  }), Xe(o, "change", u, { passive: !0 }), se(() => l.value);
}
function Kn(e, t = {}) {
  function n(m, f) {
    let M = X(e[X(m)]);
    return f != null && (M = In(M, f)), typeof M == "number" && (M = `${M}px`), M;
  }
  const { window: r = me, strategy: a = "min-width", ssrWidth: i = Qt() } = t, o = typeof i == "number", l = o ? Z(!1) : { value: !0 };
  o && Gt(() => l.value = !!r);
  function u(m, f) {
    return !l.value && o ? m === "min" ? i >= ie(f) : i <= ie(f) : r ? r.matchMedia(`(${m}-width: ${f})`).matches : !1;
  }
  const s = (m) => re(() => `(min-width: ${n(m)})`, t), d = (m) => re(() => `(max-width: ${n(m)})`, t), c = Object.keys(e).reduce((m, f) => (Object.defineProperty(m, f, {
    get: () => a === "min-width" ? s(f) : d(f),
    enumerable: !0,
    configurable: !0
  }), m), {});
  function h() {
    const m = Object.keys(e).map((f) => [f, c[f], ie(n(f))]).sort((f, M) => f[2] - M[2]);
    return se(() => m.filter(([, f]) => f.value).map(([f]) => f));
  }
  return Object.assign(c, {
    greaterOrEqual: s,
    smallerOrEqual: d,
    greater(m) {
      return re(() => `(min-width: ${n(m, 0.1)})`, t);
    },
    smaller(m) {
      return re(() => `(max-width: ${n(m, -0.1)})`, t);
    },
    between(m, f) {
      return re(() => `(min-width: ${n(m)}) and (max-width: ${n(f, -0.1)})`, t);
    },
    isGreater(m) {
      return u("min", n(m, 0.1));
    },
    isGreaterOrEqual(m) {
      return u("min", n(m));
    },
    isSmaller(m) {
      return u("max", n(m, -0.1));
    },
    isSmallerOrEqual(m) {
      return u("max", n(m));
    },
    isInBetween(m, f) {
      return u("min", n(m)) && u("max", n(f, -0.1));
    },
    current: h,
    active() {
      const m = h();
      return se(() => m.value.length === 0 ? "" : m.value.at(a === "min-width" ? -1 : 0));
    }
  });
}
function Vi(e = {}) {
  const {
    window: t = me,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: a = !0,
    includeScrollbar: i = !0,
    type: o = "inner"
  } = e, l = Z(n), u = Z(r), s = () => {
    if (t)
      if (o === "outer")
        l.value = t.outerWidth, u.value = t.outerHeight;
      else if (o === "visual" && t.visualViewport) {
        const { width: c, height: h, scale: m } = t.visualViewport;
        l.value = Math.round(c * m), u.value = Math.round(h * m);
      } else i ? (l.value = t.innerWidth, u.value = t.innerHeight) : (l.value = t.document.documentElement.clientWidth, u.value = t.document.documentElement.clientHeight);
  };
  s(), Gt(s);
  const d = { passive: !0 };
  if (Xe("resize", s, d), t && o === "visual" && t.visualViewport && Xe(t.visualViewport, "resize", s, d), a) {
    const c = re("(orientation: portrait)");
    Ge(c, () => s());
  }
  return { width: l, height: u };
}
function Hi() {
  const e = Kn(Tn), t = e.greaterOrEqual("sm"), n = e.greaterOrEqual("md"), r = e.greaterOrEqual("lg"), a = e.greaterOrEqual("xl");
  return {
    breakpoints: e,
    sm: t,
    md: n,
    lg: r,
    xl: a
  };
}
const Jn = {
  lessThanXSeconds: {
    one: {
      regular: "méně než 1 sekunda",
      past: "před méně než 1 sekundou",
      future: "za méně než 1 sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "1 sekunda",
      past: "před 1 sekundou",
      future: "za 1 sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než 1 minuta",
      past: "před méně než 1 minutou",
      future: "za méně než 1 minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "1 minuta",
      past: "před 1 minutou",
      future: "za 1 minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně 1 hodina",
      past: "přibližně před 1 hodinou",
      future: "přibližně za 1 hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "1 hodina",
      past: "před 1 hodinou",
      future: "za 1 hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "1 den",
      past: "před 1 dnem",
      future: "za 1 den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně 1 týden",
      past: "přibližně před 1 týdnem",
      future: "přibližně za 1 týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "1 týden",
      past: "před 1 týdnem",
      future: "za 1 týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně 1 měsíc",
      past: "přibližně před 1 měsícem",
      future: "přibližně za 1 měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "1 měsíc",
      past: "před 1 měsícem",
      future: "za 1 měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně 1 rok",
      past: "přibližně před 1 rokem",
      future: "přibližně za 1 rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "1 rok",
      past: "před 1 rokem",
      future: "za 1 rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než 1 rok",
      past: "před více než 1 rokem",
      future: "za více než 1 rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro 1 rok",
      past: "skoro před 1 rokem",
      future: "skoro za 1 rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, Zn = (e, t, n) => {
  let r;
  const a = Jn[e];
  a.type === "other" ? r = a.other : t === 1 ? r = a.one : t > 1 && t < 5 ? r = a.few : r = a.many;
  const i = n?.addSuffix === !0, o = n?.comparison;
  let l;
  return i && o === -1 ? l = r.past : i && o === 1 ? l = r.future : l = r.regular, l.replace("{{count}}", String(t));
};
function N(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const er = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, tr = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, nr = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rr = {
  date: N({
    formats: er,
    defaultWidth: "full"
  }),
  time: N({
    formats: tr,
    defaultWidth: "full"
  }),
  dateTime: N({
    formats: nr,
    defaultWidth: "full"
  })
}, ar = [
  "neděli",
  "pondělí",
  "úterý",
  "středu",
  "čtvrtek",
  "pátek",
  "sobotu"
], or = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: (e) => {
    const t = e.getDay();
    return "'v " + ar[t] + " o' p";
  },
  other: "P"
}, ir = (e, t) => {
  const n = or[e];
  return typeof n == "function" ? n(t) : n;
};
function z(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, l = n?.width ? String(n.width) : o;
      a = e.formattingValues[l] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, l = n?.width ? String(n.width) : e.defaultWidth;
      a = e.values[l] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const sr = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, ur = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, lr = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec"
  ]
}, dr = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "ledna",
    "února",
    "března",
    "dubna",
    "května",
    "června",
    "července",
    "srpna",
    "září",
    "října",
    "listopadu",
    "prosince"
  ]
}, cr = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, fr = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, mr = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, pr = (e, t) => Number(e) + ".", hr = {
  ordinalNumber: pr,
  era: z({
    values: sr,
    defaultWidth: "wide"
  }),
  quarter: z({
    values: ur,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: z({
    values: lr,
    defaultWidth: "wide",
    formattingValues: dr,
    defaultFormattingWidth: "wide"
  }),
  day: z({
    values: cr,
    defaultWidth: "wide"
  }),
  dayPeriod: z({
    values: fr,
    defaultWidth: "wide",
    formattingValues: mr,
    defaultFormattingWidth: "wide"
  })
};
function T(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], l = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(l) ? br(l, (c) => c.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      gr(l, (c) => c.test(o))
    );
    let s;
    s = e.valueCallback ? e.valueCallback(u) : u, s = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(s)
    ) : s;
    const d = t.slice(o.length);
    return { value: s, rest: d };
  };
}
function gr(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function br(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ue(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const l = t.slice(a.length);
    return { value: o, rest: l };
  };
}
const vr = /^(\d+)\.?/i, yr = /\d+/i, wr = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, xr = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, Pr = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, kr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Or = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, Mr = {
  narrow: [
    /^l/i,
    /^[úu]/i,
    /^b/i,
    /^d/i,
    /^k/i,
    /^[čc]/i,
    /^[čc]/i,
    /^s/i,
    /^z/i,
    /^[řr]/i,
    /^l/i,
    /^p/i
  ],
  any: [
    /^led/i,
    /^[úu]n/i,
    /^b[řr]e/i,
    /^dub/i,
    /^kv[ěe]/i,
    /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
    /^[čc]vc|[čc]erven(ec|ce)/i,
    /^srp/i,
    /^z[áa][řr]/i,
    /^[řr][íi]j/i,
    /^lis/i,
    /^pro/i
  ]
}, Wr = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, Cr = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, Sr = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, jr = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, $r = {
  ordinalNumber: ue({
    matchPattern: vr,
    parsePattern: yr,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: T({
    matchPatterns: wr,
    defaultMatchWidth: "wide",
    parsePatterns: xr,
    defaultParseWidth: "any"
  }),
  quarter: T({
    matchPatterns: Pr,
    defaultMatchWidth: "wide",
    parsePatterns: kr,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: T({
    matchPatterns: Or,
    defaultMatchWidth: "wide",
    parsePatterns: Mr,
    defaultParseWidth: "any"
  }),
  day: T({
    matchPatterns: Wr,
    defaultMatchWidth: "wide",
    parsePatterns: Cr,
    defaultParseWidth: "any"
  }),
  dayPeriod: T({
    matchPatterns: Sr,
    defaultMatchWidth: "any",
    parsePatterns: jr,
    defaultParseWidth: "any"
  })
}, jt = {
  code: "cs",
  formatDistance: Zn,
  formatLong: rr,
  formatRelative: ir,
  localize: hr,
  match: $r,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Er = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
}, Ar = (e, t, n) => {
  let r;
  const a = Er[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "în " + r : r + " în urmă" : r;
}, _r = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
}, Dr = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, zr = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Tr = {
  date: N({
    formats: _r,
    defaultWidth: "full"
  }),
  time: N({
    formats: Dr,
    defaultWidth: "full"
  }),
  dateTime: N({
    formats: zr,
    defaultWidth: "full"
  })
}, Fr = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
}, Lr = (e, t, n, r) => Fr[e], qr = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
}, Rr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: [
    "primul trimestru",
    "al doilea trimestru",
    "al treilea trimestru",
    "al patrulea trimestru"
  ]
}, Vr = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "ian",
    "feb",
    "mar",
    "apr",
    "mai",
    "iun",
    "iul",
    "aug",
    "sep",
    "oct",
    "noi",
    "dec"
  ],
  wide: [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie"
  ]
}, Hr = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
}, Ir = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, Nr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, Br = (e, t) => String(e), Ur = {
  ordinalNumber: Br,
  era: z({
    values: qr,
    defaultWidth: "wide"
  }),
  quarter: z({
    values: Rr,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: z({
    values: Vr,
    defaultWidth: "wide"
  }),
  day: z({
    values: Hr,
    defaultWidth: "wide"
  }),
  dayPeriod: z({
    values: Ir,
    defaultWidth: "wide",
    formattingValues: Nr,
    defaultFormattingWidth: "wide"
  })
}, Yr = /^(\d+)?/i, Xr = /\d+/i, Gr = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
}, Qr = {
  any: [/^ÎC/i, /^DC/i],
  wide: [
    /^(Înainte de Cristos|Înaintea erei noastre)/i,
    /^(După Cristos|Era noastră)/i
  ]
}, Kr = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
}, Jr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zr = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
}, ea = {
  narrow: [
    /^i/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ia/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^iun/i,
    /^iul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ta = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
}, na = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
}, ra = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
}, aa = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
}, oa = {
  ordinalNumber: ue({
    matchPattern: Yr,
    parsePattern: Xr,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: T({
    matchPatterns: Gr,
    defaultMatchWidth: "wide",
    parsePatterns: Qr,
    defaultParseWidth: "any"
  }),
  quarter: T({
    matchPatterns: Kr,
    defaultMatchWidth: "wide",
    parsePatterns: Jr,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: T({
    matchPatterns: Zr,
    defaultMatchWidth: "wide",
    parsePatterns: ea,
    defaultParseWidth: "any"
  }),
  day: T({
    matchPatterns: ta,
    defaultMatchWidth: "wide",
    parsePatterns: na,
    defaultParseWidth: "any"
  }),
  dayPeriod: T({
    matchPatterns: ra,
    defaultMatchWidth: "any",
    parsePatterns: aa,
    defaultParseWidth: "any"
  })
}, ia = {
  code: "ro",
  formatDistance: Ar,
  formatLong: Tr,
  formatRelative: Lr,
  localize: Ur,
  match: oa,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function sa(e, t) {
  return t === 1 && e.one ? e.one : t >= 2 && t <= 4 && e.twoFour ? e.twoFour : e.other;
}
function Ne(e, t, n) {
  return sa(e, t)[n].replace("{{count}}", String(t));
}
function ua(e) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(n) {
      return !!e.match(new RegExp("^" + n));
    }
  )[0];
}
function Be(e) {
  let t = "";
  return e === "almost" && (t = "takmer"), e === "about" && (t = "približne"), t.length > 0 ? t + " " : "";
}
function Ue(e) {
  let t = "";
  return e === "lessThan" && (t = "menej než"), e === "over" && (t = "viac než"), t.length > 0 ? t + " " : "";
}
function la(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
const da = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, ca = (e, t, n) => {
  const r = ua(e) || "", a = la(e.substring(r.length)), i = da[a];
  return n?.addSuffix ? n.comparison && n.comparison > 0 ? Be(r) + "o " + Ue(r) + Ne(i, t, "future") : Be(r) + "pred " + Ue(r) + Ne(i, t, "past") : Be(r) + Ue(r) + Ne(i, t, "present");
}, fa = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, ma = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, pa = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, ha = {
  date: N({
    formats: fa,
    defaultWidth: "full"
  }),
  time: N({
    formats: ma,
    defaultWidth: "full"
  }),
  dateTime: N({
    formats: pa,
    defaultWidth: "full"
  })
};
function Y(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
let ga = {};
function pe() {
  return ga;
}
function ee(e, t) {
  const n = pe(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, a = Y(e), i = a.getDay(), o = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function $t(e, t, n) {
  const r = ee(e, n), a = ee(t, n);
  return +r == +a;
}
const et = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function ba(e) {
  const t = et[e];
  switch (e) {
    case 0:
    /* Sun */
    case 3:
    /* Wed */
    case 6:
      return "'minulú " + t + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function Et(e) {
  const t = et[e];
  return e === 4 ? "'vo' eeee 'o' p" : "'v " + t + " o' p";
}
function va(e) {
  const t = et[e];
  switch (e) {
    case 0:
    /* Sun */
    case 4:
    /* Wed */
    case 6:
      return "'budúcu " + t + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const ya = {
  lastWeek: (e, t, n) => {
    const r = e.getDay();
    return $t(e, t, n) ? Et(r) : ba(r);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (e, t, n) => {
    const r = e.getDay();
    return $t(e, t, n) ? Et(r) : va(r);
  },
  other: "P"
}, wa = (e, t, n, r) => {
  const a = ya[e];
  return typeof a == "function" ? a(t, n, r) : a;
}, xa = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, Pa = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, ka = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, Oa = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, Ma = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, Wa = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, Ca = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, Sa = (e, t) => Number(e) + ".", ja = {
  ordinalNumber: Sa,
  era: z({
    values: xa,
    defaultWidth: "wide"
  }),
  quarter: z({
    values: Pa,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: z({
    values: ka,
    defaultWidth: "wide",
    formattingValues: Oa,
    defaultFormattingWidth: "wide"
  }),
  day: z({
    values: Ma,
    defaultWidth: "wide"
  }),
  dayPeriod: z({
    values: Wa,
    defaultWidth: "wide",
    formattingValues: Ca,
    defaultFormattingWidth: "wide"
  })
}, $a = /^(\d+)\.?/i, Ea = /\d+/i, Aa = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, _a = {
  any: [/^pr/i, /^(po|n)/i]
}, Da = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, za = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ta = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, Fa = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, La = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, qa = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, Ra = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, Va = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, Ha = {
  ordinalNumber: ue({
    matchPattern: $a,
    parsePattern: Ea,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: T({
    matchPatterns: Aa,
    defaultMatchWidth: "wide",
    parsePatterns: _a,
    defaultParseWidth: "any"
  }),
  quarter: T({
    matchPatterns: Da,
    defaultMatchWidth: "wide",
    parsePatterns: za,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: T({
    matchPatterns: Ta,
    defaultMatchWidth: "wide",
    parsePatterns: Fa,
    defaultParseWidth: "any"
  }),
  day: T({
    matchPatterns: La,
    defaultMatchWidth: "wide",
    parsePatterns: qa,
    defaultParseWidth: "any"
  }),
  dayPeriod: T({
    matchPatterns: Ra,
    defaultMatchWidth: "any",
    parsePatterns: Va,
    defaultParseWidth: "any"
  })
}, Ia = {
  code: "sk",
  formatDistance: ca,
  formatLong: ha,
  formatRelative: wa,
  localize: ja,
  match: Ha,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Na = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, Ba = (e, t, n) => {
  let r;
  const a = Na[e];
  return typeof a == "string" ? r = a : t === 1 ? n?.addSuffix ? n.comparison && n.comparison > 0 ? r = a.one.withPrepositionIn : r = a.one.withPrepositionAgo : r = a.one.standalone : t % 10 > 1 && t % 10 < 5 && // if last digit is between 2 and 4
  String(t).substr(-2, 1) !== "1" ? r = a.dual.replace("{{count}}", String(t)) : r = a.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "za " + r : "pre " + r : r;
}, Ua = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, Ya = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Xa = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ga = {
  date: N({
    formats: Ua,
    defaultWidth: "full"
  }),
  time: N({
    formats: Ya,
    defaultWidth: "full"
  }),
  dateTime: N({
    formats: Xa,
    defaultWidth: "full"
  })
}, Qa = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P"
}, Ka = (e, t, n, r) => {
  const a = Qa[e];
  return typeof a == "function" ? a(t) : a;
}, Ja = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
}, Za = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, eo = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, to = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, no = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedelja",
    "ponedeljak",
    "utorak",
    "sreda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, ro = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, ao = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, oo = (e, t) => Number(e) + ".", io = {
  ordinalNumber: oo,
  era: z({
    values: Ja,
    defaultWidth: "wide"
  }),
  quarter: z({
    values: Za,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: z({
    values: eo,
    defaultWidth: "wide",
    formattingValues: to,
    defaultFormattingWidth: "wide"
  }),
  day: z({
    values: no,
    defaultWidth: "wide"
  }),
  dayPeriod: z({
    values: ao,
    defaultWidth: "wide",
    formattingValues: ro,
    defaultFormattingWidth: "wide"
  })
}, so = /^(\d+)\./i, uo = /\d+/i, lo = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
}, co = {
  any: [/^pr/i, /^(po|nova)/i]
}, fo = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, mo = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, po = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, ho = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, go = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
}, bo = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vo = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
}, yo = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, wo = {
  ordinalNumber: ue({
    matchPattern: so,
    parsePattern: uo,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: T({
    matchPatterns: lo,
    defaultMatchWidth: "wide",
    parsePatterns: co,
    defaultParseWidth: "any"
  }),
  quarter: T({
    matchPatterns: fo,
    defaultMatchWidth: "wide",
    parsePatterns: mo,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: T({
    matchPatterns: po,
    defaultMatchWidth: "wide",
    parsePatterns: ho,
    defaultParseWidth: "any"
  }),
  day: T({
    matchPatterns: go,
    defaultMatchWidth: "wide",
    parsePatterns: bo,
    defaultParseWidth: "any"
  }),
  dayPeriod: T({
    matchPatterns: vo,
    defaultMatchWidth: "any",
    parsePatterns: yo,
    defaultParseWidth: "any"
  })
}, xo = {
  code: "sr-Latn",
  formatDistance: Ba,
  formatLong: Ga,
  formatRelative: Ka,
  localize: io,
  match: wo,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Po = pn.localeSettings.locale, Ii = (() => {
  switch (Po) {
    case "cs":
      return jt;
    case "ro":
      return ia;
    case "sr":
      return xo;
    case "sk":
      return Ia;
    default:
      return jt;
  }
})();
function te(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
const Kt = 6048e5, ko = 864e5, Ni = 6e4, Bi = 36e5;
function ce(e) {
  return ee(e, { weekStartsOn: 1 });
}
function Jt(e) {
  const t = Y(e), n = t.getFullYear(), r = te(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = ce(r), i = te(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const o = ce(i);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function At(e) {
  const t = Y(e);
  return t.setHours(0, 0, 0, 0), t;
}
function _t(e) {
  const t = Y(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Oo(e, t) {
  const n = At(e), r = At(t), a = +n - _t(n), i = +r - _t(r);
  return Math.round((a - i) / ko);
}
function Mo(e) {
  const t = Jt(e), n = te(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), ce(n);
}
function Wo(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Co(e) {
  if (!Wo(e) && typeof e != "number")
    return !1;
  const t = Y(e);
  return !isNaN(Number(t));
}
function So(e) {
  const t = Y(e), n = te(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const jo = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, $o = (e, t, n) => {
  let r;
  const a = jo[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
}, Eo = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ao = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, _o = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Do = {
  date: N({
    formats: Eo,
    defaultWidth: "full"
  }),
  time: N({
    formats: Ao,
    defaultWidth: "full"
  }),
  dateTime: N({
    formats: _o,
    defaultWidth: "full"
  })
}, zo = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, To = (e, t, n, r) => zo[e], Fo = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Lo = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, qo = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ro = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Vo = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ho = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Io = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, No = {
  ordinalNumber: Io,
  era: z({
    values: Fo,
    defaultWidth: "wide"
  }),
  quarter: z({
    values: Lo,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: z({
    values: qo,
    defaultWidth: "wide"
  }),
  day: z({
    values: Ro,
    defaultWidth: "wide"
  }),
  dayPeriod: z({
    values: Vo,
    defaultWidth: "wide",
    formattingValues: Ho,
    defaultFormattingWidth: "wide"
  })
}, Bo = /^(\d+)(th|st|nd|rd)?/i, Uo = /\d+/i, Yo = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Xo = {
  any: [/^b/i, /^(a|c)/i]
}, Go = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Qo = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ko = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Jo = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Zo = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ei = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ti = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ni = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ri = {
  ordinalNumber: ue({
    matchPattern: Bo,
    parsePattern: Uo,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: T({
    matchPatterns: Yo,
    defaultMatchWidth: "wide",
    parsePatterns: Xo,
    defaultParseWidth: "any"
  }),
  quarter: T({
    matchPatterns: Go,
    defaultMatchWidth: "wide",
    parsePatterns: Qo,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: T({
    matchPatterns: Ko,
    defaultMatchWidth: "wide",
    parsePatterns: Jo,
    defaultParseWidth: "any"
  }),
  day: T({
    matchPatterns: Zo,
    defaultMatchWidth: "wide",
    parsePatterns: ei,
    defaultParseWidth: "any"
  }),
  dayPeriod: T({
    matchPatterns: ti,
    defaultMatchWidth: "any",
    parsePatterns: ni,
    defaultParseWidth: "any"
  })
}, ai = {
  code: "en-US",
  formatDistance: $o,
  formatLong: Do,
  formatRelative: To,
  localize: No,
  match: ri,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function oi(e) {
  const t = Y(e);
  return Oo(t, So(t)) + 1;
}
function ii(e) {
  const t = Y(e), n = +ce(t) - +Mo(t);
  return Math.round(n / Kt) + 1;
}
function Zt(e, t) {
  const n = Y(e), r = n.getFullYear(), a = pe(), i = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, o = te(e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const l = ee(o, t), u = te(e, 0);
  u.setFullYear(r, 0, i), u.setHours(0, 0, 0, 0);
  const s = ee(u, t);
  return n.getTime() >= l.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function si(e, t) {
  const n = pe(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, a = Zt(e, t), i = te(e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), ee(i, t);
}
function ui(e, t) {
  const n = Y(e), r = +ee(n, t) - +si(n, t);
  return Math.round(r / Kt) + 1;
}
function A(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Q = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return A(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : A(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return A(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return A(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return A(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return A(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return A(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return A(a, t.length);
  }
}, ne = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Dt = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return Q.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = Zt(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return A(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : A(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Jt(e);
    return A(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return A(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return A(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return A(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Q.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return A(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = ui(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : A(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = ii(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : A(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Q.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = oi(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : A(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return A(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return A(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return A(a, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = ne.noon : r === 0 ? a = ne.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = ne.evening : r >= 12 ? a = ne.afternoon : r >= 4 ? a = ne.morning : a = ne.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Q.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Q.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : A(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : A(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Q.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Q.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Q.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Tt(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return J(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return J(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Tt(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return J(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return J(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + zt(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + J(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + zt(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + J(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return A(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return A(r, t.length);
  }
};
function zt(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + A(i, 2);
}
function Tt(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + A(Math.abs(e) / 60, 2) : J(e, t);
}
function J(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = A(Math.trunc(r / 60), 2), i = A(r % 60, 2);
  return n + a + t + i;
}
const Ft = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, en = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, li = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return Ft(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Ft(r, t)).replace("{{time}}", en(a, t));
}, di = {
  p: en,
  P: li
}, ci = /^D+$/, fi = /^Y+$/, mi = ["D", "DD", "YY", "YYYY"];
function pi(e) {
  return ci.test(e);
}
function hi(e) {
  return fi.test(e);
}
function gi(e, t, n) {
  const r = bi(e, t, n);
  if (console.warn(r), mi.includes(e)) throw new RangeError(r);
}
function bi(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const vi = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, yi = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, wi = /^'([^]*?)'?$/, xi = /''/g, Pi = /[a-zA-Z]/;
function Ui(e, t, n) {
  const r = pe(), a = n?.locale ?? r.locale ?? ai, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, l = Y(e);
  if (!Co(l))
    throw new RangeError("Invalid time value");
  let u = t.match(yi).map((d) => {
    const c = d[0];
    if (c === "p" || c === "P") {
      const h = di[c];
      return h(d, a.formatLong);
    }
    return d;
  }).join("").match(vi).map((d) => {
    if (d === "''")
      return { isToken: !1, value: "'" };
    const c = d[0];
    if (c === "'")
      return { isToken: !1, value: ki(d) };
    if (Dt[c])
      return { isToken: !0, value: d };
    if (c.match(Pi))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + c + "`"
      );
    return { isToken: !1, value: d };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(l, u));
  const s = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return u.map((d) => {
    if (!d.isToken) return d.value;
    const c = d.value;
    (!n?.useAdditionalWeekYearTokens && hi(c) || !n?.useAdditionalDayOfYearTokens && pi(c)) && gi(c, t, String(e));
    const h = Dt[c[0]];
    return h(l, c, a.localize, s);
  }).join("");
}
function ki(e) {
  const t = e.match(wi);
  return t ? t[1].replace(xi, "'") : e;
}
/*! Capacitor: https://capacitorjs.com/ - MIT License */
const Oi = (e) => {
  const t = /* @__PURE__ */ new Map();
  t.set("web", { name: "web" });
  const n = e.CapacitorPlatforms || {
    currentPlatform: { name: "web" },
    platforms: t
  }, r = (i, o) => {
    n.platforms.set(i, o);
  }, a = (i) => {
    n.platforms.has(i) && (n.currentPlatform = n.platforms.get(i));
  };
  return n.addPlatform = r, n.setPlatform = a, n;
}, Mi = (e) => e.CapacitorPlatforms = Oi(e), tn = /* @__PURE__ */ Mi(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
tn.addPlatform;
tn.setPlatform;
var ae;
(function(e) {
  e.Unimplemented = "UNIMPLEMENTED", e.Unavailable = "UNAVAILABLE";
})(ae || (ae = {}));
class Ye extends Error {
  constructor(t, n, r) {
    super(t), this.message = t, this.code = n, this.data = r;
  }
}
const Wi = (e) => {
  var t, n;
  return e?.androidBridge ? "android" : !((n = (t = e?.webkit) === null || t === void 0 ? void 0 : t.messageHandlers) === null || n === void 0) && n.bridge ? "ios" : "web";
}, Ci = (e) => {
  var t, n, r, a, i;
  const o = e.CapacitorCustomPlatform || null, l = e.Capacitor || {}, u = l.Plugins = l.Plugins || {}, s = e.CapacitorPlatforms, d = () => o !== null ? o.name : Wi(e), c = ((t = s?.currentPlatform) === null || t === void 0 ? void 0 : t.getPlatform) || d, h = () => c() !== "web", m = ((n = s?.currentPlatform) === null || n === void 0 ? void 0 : n.isNativePlatform) || h, f = ($) => {
    const E = D.get($);
    return !!(E?.platforms.has(c()) || F($));
  }, M = ((r = s?.currentPlatform) === null || r === void 0 ? void 0 : r.isPluginAvailable) || f, S = ($) => {
    var E;
    return (E = l.PluginHeaders) === null || E === void 0 ? void 0 : E.find((b) => b.name === $);
  }, F = ((a = s?.currentPlatform) === null || a === void 0 ? void 0 : a.getPluginHeader) || S, L = ($) => e.console.error($), _ = ($, E, b) => Promise.reject(`${b} does not have an implementation of "${E}".`), D = /* @__PURE__ */ new Map(), q = ($, E = {}) => {
    const b = D.get($);
    if (b)
      return console.warn(`Capacitor plugin "${$}" already registered. Cannot register plugins twice.`), b.proxy;
    const x = c(), P = F($);
    let p;
    const y = async () => (!p && x in E ? p = typeof E[x] == "function" ? p = await E[x]() : p = E[x] : o !== null && !p && "web" in E && (p = typeof E.web == "function" ? p = await E.web() : p = E.web), p), O = (w, j) => {
      var B, R;
      if (P) {
        const U = P?.methods.find((H) => j === H.name);
        if (U)
          return U.rtype === "promise" ? (H) => l.nativePromise($, j.toString(), H) : (H, G) => l.nativeCallback($, j.toString(), H, G);
        if (w)
          return (B = w[j]) === null || B === void 0 ? void 0 : B.bind(w);
      } else {
        if (w)
          return (R = w[j]) === null || R === void 0 ? void 0 : R.bind(w);
        throw new Ye(`"${$}" plugin is not implemented on ${x}`, ae.Unimplemented);
      }
    }, v = (w) => {
      let j;
      const B = (...R) => {
        const U = y().then((H) => {
          const G = O(H, w);
          if (G) {
            const I = G(...R);
            return j = I?.remove, I;
          } else
            throw new Ye(`"${$}.${w}()" is not implemented on ${x}`, ae.Unimplemented);
        });
        return w === "addListener" && (U.remove = async () => j()), U;
      };
      return B.toString = () => `${w.toString()}() { [capacitor code] }`, Object.defineProperty(B, "name", {
        value: w,
        writable: !1,
        configurable: !1
      }), B;
    }, W = v("addListener"), g = v("removeListener"), k = (w, j) => {
      const B = W({ eventName: w }, j), R = async () => {
        const H = await B;
        g({
          eventName: w,
          callbackId: H
        }, j);
      }, U = new Promise((H) => B.then(() => H({ remove: R })));
      return U.remove = async () => {
        console.warn("Using addListener() without 'await' is deprecated."), await R();
      }, U;
    }, C = new Proxy({}, {
      get(w, j) {
        switch (j) {
          // https://github.com/facebook/react/issues/20030
          case "$$typeof":
            return;
          case "toJSON":
            return () => ({});
          case "addListener":
            return P ? k : W;
          case "removeListener":
            return g;
          default:
            return v(j);
        }
      }
    });
    return u[$] = C, D.set($, {
      name: $,
      proxy: C,
      platforms: /* @__PURE__ */ new Set([
        ...Object.keys(E),
        ...P ? [x] : []
      ])
    }), C;
  }, V = ((i = s?.currentPlatform) === null || i === void 0 ? void 0 : i.registerPlugin) || q;
  return l.convertFileSrc || (l.convertFileSrc = ($) => $), l.getPlatform = c, l.handleError = L, l.isNativePlatform = m, l.isPluginAvailable = M, l.pluginMethodNoop = _, l.registerPlugin = V, l.Exception = Ye, l.DEBUG = !!l.DEBUG, l.isLoggingEnabled = !!l.isLoggingEnabled, l.platform = l.getPlatform(), l.isNative = l.isNativePlatform(), l;
}, Si = (e) => e.Capacitor = Ci(e), fe = /* @__PURE__ */ Si(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), nn = fe.registerPlugin;
fe.Plugins;
class rn {
  constructor(t) {
    this.listeners = {}, this.retainedEventArguments = {}, this.windowListeners = {}, t && (console.warn(`Capacitor WebPlugin "${t.name}" config object was deprecated in v3 and will be removed in v4.`), this.config = t);
  }
  addListener(t, n) {
    let r = !1;
    this.listeners[t] || (this.listeners[t] = [], r = !0), this.listeners[t].push(n);
    const i = this.windowListeners[t];
    i && !i.registered && this.addWindowListener(i), r && this.sendRetainedArgumentsForEvent(t);
    const o = async () => this.removeListener(t, n);
    return Promise.resolve({ remove: o });
  }
  async removeAllListeners() {
    this.listeners = {};
    for (const t in this.windowListeners)
      this.removeWindowListener(this.windowListeners[t]);
    this.windowListeners = {};
  }
  notifyListeners(t, n, r) {
    const a = this.listeners[t];
    if (!a) {
      if (r) {
        let i = this.retainedEventArguments[t];
        i || (i = []), i.push(n), this.retainedEventArguments[t] = i;
      }
      return;
    }
    a.forEach((i) => i(n));
  }
  hasListeners(t) {
    return !!this.listeners[t].length;
  }
  registerWindowListener(t, n) {
    this.windowListeners[n] = {
      registered: !1,
      windowEventName: t,
      pluginEventName: n,
      handler: (r) => {
        this.notifyListeners(n, r);
      }
    };
  }
  unimplemented(t = "not implemented") {
    return new fe.Exception(t, ae.Unimplemented);
  }
  unavailable(t = "not available") {
    return new fe.Exception(t, ae.Unavailable);
  }
  async removeListener(t, n) {
    const r = this.listeners[t];
    if (!r)
      return;
    const a = r.indexOf(n);
    this.listeners[t].splice(a, 1), this.listeners[t].length || this.removeWindowListener(this.windowListeners[t]);
  }
  addWindowListener(t) {
    window.addEventListener(t.windowEventName, t.handler), t.registered = !0;
  }
  removeWindowListener(t) {
    t && (window.removeEventListener(t.windowEventName, t.handler), t.registered = !1);
  }
  sendRetainedArgumentsForEvent(t) {
    const n = this.retainedEventArguments[t];
    n && (delete this.retainedEventArguments[t], n.forEach((r) => {
      this.notifyListeners(t, r);
    }));
  }
}
const Lt = (e) => encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), qt = (e) => e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class ji extends rn {
  async getCookies() {
    const t = document.cookie, n = {};
    return t.split(";").forEach((r) => {
      if (r.length <= 0)
        return;
      let [a, i] = r.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
      a = qt(a).trim(), i = qt(i).trim(), n[a] = i;
    }), n;
  }
  async setCookie(t) {
    try {
      const n = Lt(t.key), r = Lt(t.value), a = `; expires=${(t.expires || "").replace("expires=", "")}`, i = (t.path || "/").replace("path=", ""), o = t.url != null && t.url.length > 0 ? `domain=${t.url}` : "";
      document.cookie = `${n}=${r || ""}${a}; path=${i}; ${o};`;
    } catch (n) {
      return Promise.reject(n);
    }
  }
  async deleteCookie(t) {
    try {
      document.cookie = `${t.key}=; Max-Age=0`;
    } catch (n) {
      return Promise.reject(n);
    }
  }
  async clearCookies() {
    try {
      const t = document.cookie.split(";") || [];
      for (const n of t)
        document.cookie = n.replace(/^ +/, "").replace(/=.*/, `=;expires=${(/* @__PURE__ */ new Date()).toUTCString()};path=/`);
    } catch (t) {
      return Promise.reject(t);
    }
  }
  async clearAllCookies() {
    try {
      await this.clearCookies();
    } catch (t) {
      return Promise.reject(t);
    }
  }
}
nn("CapacitorCookies", {
  web: () => new ji()
});
const $i = async (e) => new Promise((t, n) => {
  const r = new FileReader();
  r.onload = () => {
    const a = r.result;
    t(a.indexOf(",") >= 0 ? a.split(",")[1] : a);
  }, r.onerror = (a) => n(a), r.readAsDataURL(e);
}), Ei = (e = {}) => {
  const t = Object.keys(e);
  return Object.keys(e).map((a) => a.toLocaleLowerCase()).reduce((a, i, o) => (a[i] = e[t[o]], a), {});
}, Ai = (e, t = !0) => e ? Object.entries(e).reduce((r, a) => {
  const [i, o] = a;
  let l, u;
  return Array.isArray(o) ? (u = "", o.forEach((s) => {
    l = t ? encodeURIComponent(s) : s, u += `${i}=${l}&`;
  }), u.slice(0, -1)) : (l = t ? encodeURIComponent(o) : o, u = `${i}=${l}`), `${r}&${u}`;
}, "").substr(1) : null, _i = (e, t = {}) => {
  const n = Object.assign({ method: e.method || "GET", headers: e.headers }, t), a = Ei(e.headers)["content-type"] || "";
  if (typeof e.data == "string")
    n.body = e.data;
  else if (a.includes("application/x-www-form-urlencoded")) {
    const i = new URLSearchParams();
    for (const [o, l] of Object.entries(e.data || {}))
      i.set(o, l);
    n.body = i.toString();
  } else if (a.includes("multipart/form-data") || e.data instanceof FormData) {
    const i = new FormData();
    if (e.data instanceof FormData)
      e.data.forEach((l, u) => {
        i.append(u, l);
      });
    else
      for (const l of Object.keys(e.data))
        i.append(l, e.data[l]);
    n.body = i;
    const o = new Headers(n.headers);
    o.delete("content-type"), n.headers = o;
  } else (a.includes("application/json") || typeof e.data == "object") && (n.body = JSON.stringify(e.data));
  return n;
};
class Di extends rn {
  /**
   * Perform an Http request given a set of options
   * @param options Options to build the HTTP request
   */
  async request(t) {
    const n = _i(t, t.webFetchExtra), r = Ai(t.params, t.shouldEncodeUrlParams), a = r ? `${t.url}?${r}` : t.url, i = await fetch(a, n), o = i.headers.get("content-type") || "";
    let { responseType: l = "text" } = i.ok ? t : {};
    o.includes("application/json") && (l = "json");
    let u, s;
    switch (l) {
      case "arraybuffer":
      case "blob":
        s = await i.blob(), u = await $i(s);
        break;
      case "json":
        u = await i.json();
        break;
      case "document":
      case "text":
      default:
        u = await i.text();
    }
    const d = {};
    return i.headers.forEach((c, h) => {
      d[h] = c;
    }), {
      data: u,
      headers: d,
      status: i.status,
      url: i.url
    };
  }
  /**
   * Perform an Http GET request given a set of options
   * @param options Options to build the HTTP request
   */
  async get(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "GET" }));
  }
  /**
   * Perform an Http POST request given a set of options
   * @param options Options to build the HTTP request
   */
  async post(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "POST" }));
  }
  /**
   * Perform an Http PUT request given a set of options
   * @param options Options to build the HTTP request
   */
  async put(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PUT" }));
  }
  /**
   * Perform an Http PATCH request given a set of options
   * @param options Options to build the HTTP request
   */
  async patch(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PATCH" }));
  }
  /**
   * Perform an Http DELETE request given a set of options
   * @param options Options to build the HTTP request
   */
  async delete(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "DELETE" }));
  }
}
nn("CapacitorHttp", {
  web: () => new Di()
});
export {
  Li as M,
  rn as W,
  Ni as a,
  Xe as b,
  te as c,
  qi as d,
  Vi as e,
  Ui as f,
  pe as g,
  Ii as l,
  Bi as m,
  nn as r,
  At as s,
  Y as t,
  Hi as u,
  Ri as w
};
//# sourceMappingURL=index-CIpdgnjs.js.map
